<yc-copyright-block
  [copyrightText]="copyrightText"
  [termsAndConditionsLink]="termsOfServiceLink"
  [privacyPolicyLink]="privacyPolicyLink">
</yc-copyright-block>